import { render, staticRenderFns } from "./DeliveryCard.vue?vue&type=template&id=022f4ed2&"
import script from "./DeliveryCard.vue?vue&type=script&lang=js&"
export * from "./DeliveryCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports